import { getLocale } from "../runtime";

const sv_pricerange = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Prisspann`
};

const pricerange = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_pricerange(inputs)
	return "priceRange";
};

export { pricerange as "priceRange" };